import React from "react";
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {RouletteDrawsComponent} from "../arena-host/new-live-casino-arena/live-casino-arena-grid/shared-components/roulette-draws.component";
import {LiveStreamingOverlayItemBox} from "./boxes/live-streaming-overlay-item/live-streaming-overlay-icon.box";
import {LiveStreamingSoundButtonComponent} from "./live-streaming-sound-button.component";
import {ILiveTableInfo} from "../../services/live-table-feeds-service/live-table-feeds.service.interface";
import {TableSeatsComponent} from "../arena-host/new-live-casino-arena/live-casino-arena-grid/shared-components/table-seats.component";

export interface LiveStreamingTileOverlayComponentProps {
    tableInfo: ILiveTableInfo;
}

export class LiveStreamingTileOverlayComponent extends OrbitComponent<LiveStreamingTileOverlayComponentProps> {

    private _padding = "1rem";

    private _renderTopRight(): React.ReactElement {
        return (
            <LiveStreamingOverlayItemBox transparent style={{position: "absolute", top: this._padding, right: this._padding}}>
                <LiveStreamingSoundButtonComponent/>
            </LiveStreamingOverlayItemBox>
        );
    }

    private _renderBottomLeft(): React.ReactElement {
        return (
            <LiveStreamingOverlayItemBox capsule style={{position: "absolute", bottom: this._padding, left: this._padding}}>
                <TableSeatsComponent isLiveStreamOverlay tableInfo={this.props.tableInfo}/>
            </LiveStreamingOverlayItemBox>
        );
    }

    private _renderBottomRight(): React.ReactElement {
        return (
            <LiveStreamingOverlayItemBox style={{position: "absolute", bottom: this._padding, right: this._padding}}>
                <RouletteDrawsComponent tableInfo={this.props.tableInfo}/>
            </LiveStreamingOverlayItemBox>
        );
    }

    render() {
        return (
            <React.Fragment>
                {this._renderTopRight()}
                {this._renderBottomLeft()}
                {this._renderBottomRight()}
            </React.Fragment>
        );
    }
}
